import React, { useEffect, useState, useContext } from "react";

import { useParams, useNavigate } from "react-router-dom";

import {
  levelnoApi,
  insertUserHistoryApi,
  setuserlevellimtApi,
} from "../http/http";

import classes from "./LevelPage.module.css";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { fetchLevel, makeLevelKeySelector } from "../store/slices/gameSlice";

import LanguageSelector from "./LanguageSelector";

import { LanguageContext } from "./LanguageContext";

import Loading from "../components/Loading";

import { AiFillHome } from "react-icons/ai";
import { LEVEL, COMMON, pageT } from "../utils/i18n";















const LevelPage = () => {

  const { level_no } = useParams();

  const navigate = useNavigate();

  const { lang } = useContext(LanguageContext);

  const t = pageT(lang, LEVEL);
  const c = pageT(lang, COMMON);
  const dispatch = useDispatch();
  const levelKey = makeLevelKeySelector(level_no, lang);
  const levelData = useSelector(
    (state) => state.game.byKey[levelKey]?.data
  );
  const levelStatus = useSelector(
    (state) => state.game.byKey[levelKey]?.status
  );

  const [level, setLevel] = useState(null);

  const [chits, setChits] = useState([]);

  const [riddle, setRiddle] = useState(null);

  const [puzzleOpened, setPuzzleOpened] = useState(false);

  const [puzzleReveal, setPuzzleReveal] = useState(false);

  const [openedChit, setOpenedChit] = useState(null);

  const [emoji, setEmoji] = useState(null);

  const [reward, setReward] = useState(0);

  const [disableClicks, setDisableClicks] = useState(true);

  const [tries, setTries] = useState(0);

  const [gameOver, setGameOver] = useState(false);

  const [silverChitOpened, setSilverChitOpened] = useState(false);

  const [goldenChitOpened, setGoldenChitOpened] = useState(false);
  const [diamondChitOpened, setDiamondChitOpened]= useState(false)

const [timeLeft, setTimeLeft] = useState(60); 
const [riddlequestion,  setRiddleQestion]=useState("")
const [riddleans, setRiddleans]=useState("")

const [loading, setLoading] = useState(true);







  useEffect(() => {

    setOpenedChit(null);

    setEmoji(null);

    setPuzzleOpened(false);

    setPuzzleReveal(false);

    setReward(0);

    setDisableClicks(true);

    setTries(0);

    setGameOver(false);

    setTimeLeft(60);
    setLoading(true);

 

  }, [level_no, lang]);



useEffect(() => {

  if (gameOver || disableClicks) return;



  if (timeLeft === 0) {

    setGameOver(true);

    return;

  }



  const timer = setInterval(() => {

    setTimeLeft((prev) => prev - 1);

  }, 1000);



  return () => clearInterval(timer);

}, [timeLeft, gameOver, disableClicks]);




useEffect(() => {
  async function fetchLevel() {
    try {
      setLoading(true);




      const res = await levelnoApi({
        level_no,
        lang,
        token: Cookies.get("token")
      });
   
      console.log(res.data.riddle.answer,"-----------res-----")
      setRiddleans(res.data.riddle.answer)
      setRiddleQestion(res.data.riddle?.question)
      setLevel(res.data.level);
      setChits(res.data.chits || []);
      setRiddle(res.data.riddle || null);

    } catch (err) {
      console.error(err);

      
      setLoading(false);

    
      navigate("/home");
    } finally {
      
      setLoading(false);
    }
  }

  fetchLevel();
}, [level_no, lang]);




  const openPuzzleChit = async() => {

    if (puzzleOpened) return;

    setPuzzleOpened(true);

 


    setTimeout(() => {

      setPuzzleReveal(true);

      setDisableClicks(false);

    }, 700);

  };



  const goNextLevel = async() => {
       
       const token=Cookies.get("token")
    const limitRes = await setuserlevellimtApi(token );
   console.log(limitRes,"----limit----------")
   if (limitRes.data.success === false) {
  alert(c.dailyLimit);
  navigate("/home");
  return;

}else{
  navigate(`/levelpage/${Number(level_no) + 1}`);
}

  };



  const goHome = () => navigate("/home");



  const handleObjectClick = (chit) => {
    

    if (disableClicks || gameOver) return;



    setOpenedChit(chit);



    setTimeout(async () => {

      const isCorrect =

        chit.object_name.trim() === riddle.answer.trim();



if (isCorrect) {



  setEmoji({ type: "correct" });

  console.log(level,"levels-------")
  setReward(level?.reward_points || 0);


  // await levelsdatainsertApi({

  //   user_id: Cookies.get("user_id"),

  //   level_no: Number(level_no),

  //   points_earned: level?.reward_points || 0,

  //   status: "completed"

  // });

   const token=Cookies.get("token")

  await insertUserHistoryApi(
    token,

{
    level_no: Number(level_no),

    points_earned: level?.reward_points || 0,
    user_title:level?.user_title,
    riddle_question:riddlequestion,
    riddle_ans:riddleans

  });





  if (Number(level_no) === 10) {

    setTimeout(() => {

      setSilverChitOpened(true);

    }, 800);

    return;

  }



  if (Number(level_no) === 20) {

    setTimeout(() => {

      setGoldenChitOpened(true);

    }, 1200);

    return;

  }

   
        if (Number(level_no) === 21) {
          setTimeout(() => {
            setDiamondChitOpened(true);
          }, 1200);
          return;
        }

        if(Number(level_no)==50){
          setTimeout(()=>{
         navigate("/game-over")
          },1500)
        }

  setTimeout(() => goNextLevel(), 1500);

}



 else {

        setTries((prev) => prev + 1);

        setEmoji({ type: "wrong" });

        setOpenedChit(null);



        if (tries + 1 >= 2) setGameOver(true);



        setTimeout(() => setEmoji(null), 1200);

      }

    }, 700);

  };



  if (!level || !riddle)

    return <div className={classes.loading}>

       <Loading />

    </div>;



return (

  <div className={classes.page}>



    {loading && <Loading />}



    {!loading && (

      <>

     

   

<div className={classes.header}>

  <div className={classes.headerRow}>

 

    <div className={classes.languageBox}>

      <LanguageSelector />

    </div>



 

    <div

      className={classes.homeIcon}

      onClick={() => navigate("/home")}

      title="Home"

    >

       <AiFillHome />

    </div>

  </div>



  <h2 className={classes.levelTitle}>

    {t.level} {level.level_no}

  </h2>

  <p className={classes.subtitle}>{t.subtitle}</p>

</div>



        {/* PUZZLE */}

        <div className={classes.topChitWrap}>

          {!puzzleOpened ? (

            <div className={classes.puzzleChitClosed} onClick={openPuzzleChit}>

              <div className={classes.fold}></div>

              <div className={classes.chitLabel}>{t.tapPuzzle}</div>

            </div>

          ) : (

            <div className={classes.puzzleChitOpen}>

              <div className={classes.chitPaper}>

                <div className={`${classes.puzzleInner} ${puzzleReveal ? classes.show : ""}`}>

                  <h3>🧩 {t.puzzleTitle}</h3>

                  <p>{riddle.question}</p>

                  <small>{t.chooseObj}</small>

                </div>

              </div>

            </div>

          )}

        </div>



        {/* SILVER CHIT */}

        {silverChitOpened && (

          <div className={classes.overlay}>

            <div className={classes.wheelModal}>

              <div className={classes.silverChit}></div>

              <h2 className={classes.title}>{t.silverUnlocked}</h2>

              <button

                className={classes.spinBtn}

                onClick={() => navigate("/silverchit")}

              >

                {t.exploreNow}

              </button>

            </div>

          </div>

        )}



{goldenChitOpened && (

  <div className={classes.overlay}>

    <div className={classes.goldModal}>

      <div className={classes.goldenChit}></div>

      <h2 className={classes.title}>{t.goldenUnlocked}</h2>

      <button

        className={classes.goldBtn}

        onClick={() => navigate("/goldenchit")}

      >

        {t.claimReward}

      </button>

    </div>

  </div>

)}

       {diamondChitOpened && (
            <div className={classes.overlay}>
              <div className={classes.diamondChitOpenedModal}>
                <div className={classes.dimondChit}></div>
                <h2 className={classes.title}>{t.diamondUnlocked}</h2>
                <button
 
                  className={classes.dimondBtn}
                  onClick={() => navigate("/diamondchit")}
                >
                  {t.claimReward}
                </button>
              </div>
            </div>
          )}


       

        {gameOver && (

          <div className={classes.gameOverBox}>

            <h2>❌ {t.gameOver}</h2>

            <p>{t.usedTries}</p>

            <div className={classes.goBtns}>

              <button className={classes.homeBtn} onClick={() => navigate(0)}>{t.restart}</button>

              <button className={classes.restartBtn} onClick={goHome}>{t.home}</button>

            </div>

          </div>

        )}



     

        <div className={classes.playgroundparent}>

           

          <div className={`${classes.playground} ${gameOver ? classes.disabledAll : ""}`}>

             <div className={classes.timer}>

   <span className={classes.timerIcon}>⏳</span> {t.timeLeft}: {timeLeft}s

  </div>

            {chits.map((c) => (

              <div key={c.id} className={classes.objectWrap} onClick={() => handleObjectClick(c)}>

                <img src={c.img_url} alt={c.object_name} className={classes.objectImg} />

                <div className={classes.objLabel}>{c.object_name}</div>

              </div>

            ))}



            {emoji && (

              <div className={`${classes.emoji} ${emoji.type === "correct" ? classes.correct : classes.wrong}`}>

                {emoji.type === "correct" ? `✨ +${reward}` : "😢"}

              </div>

            )}

          </div>

        </div>

      </>

    )}



  </div>

);



};



export default LevelPage;